<app-top-nav></app-top-nav>
<div class="content">
  <div class="wrapper">
    <p class="title">Import buildings from LOM</p>
    <div class="row">
      <div class="form-group">
        <label for="area-selector">Area</label>
        <app-area-selector id="area-selector" class="vertical-flex" (blockUpdated)="onBlockUpdated($event)"
          (fiberhoodUpdated)="onFiberhoodUpdated($event)"></app-area-selector>
      </div>
    </div>
    <div class="row">
      <div class="form-group import-type">
        <label for="type-input">Import Type</label>
        <p-dropdown [options]="importTypes" placeholder="Select the Import Type" id="type-input"
          [(ngModel)]="selectedType" optionDisabled="Import Type" (onChange)="setImportValuesTexts()"
          class="p-fluid"></p-dropdown>
      </div>
      <div class="form-group import-values">
        <label for="building-input">{{inputTitle}}</label>
        <p-chips [(ngModel)]="values" [disabled]="selectedType === undefined" separator="," id="building-input"
          aria-describedby="building-input-help" class="p-fluid">
        </p-chips>
        <small id="input-error" class="p-error"></small>
        <small id="input-help">{{inputDetails}}</small>
      </div>
    </div>
    <div class="row">
      <div class="form-group col button-row">
        <p-button (onClick)="submit()" [disabled]="!canSubmit()">Submit</p-button>
      </div>
    </div>
  </div>
</div>
